import { render, staticRenderFns } from "./domaine-claude-dugat.vue?vue&type=template&id=59a173c9&scoped=true"
import script from "./domaine-claude-dugat.vue?vue&type=script&lang=js"
export * from "./domaine-claude-dugat.vue?vue&type=script&lang=js"
import style0 from "./domaine-claude-dugat.vue?vue&type=style&index=0&id=59a173c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a173c9",
  null
  
)

export default component.exports